import React from 'react';
import AboutTemplate from './AboutTemplate';
import { platformData } from './platformData';

const FamilyRiskAbout = () => {
  return (
    <AboutTemplate
      {...platformData.familyrisk}
      platformKey="familyrisk"
    />
  );
};

export default FamilyRiskAbout;
